import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

export function Table({ className, wrapperClassName, ...props }: ComponentProps<'table'> & { wrapperClassName?: string }) {
  return (
    <div className={cn('scrollbar-none relative w-full overflow-x-auto', wrapperClassName)}>
      <table className={cn('w-full caption-bottom text-sm', className)} {...props} />
    </div>
  )
}
export function THead({ className, ...props }: ComponentProps<'thead'>) {
  return (
    <thead
      className={cn(
        'bg-primary/20 dark:bg-primary/25 [&_tr]:border-b [&_tr]:border-primary/30 [&_tr:hover]:bg-transparent',
        className,
      )}
      {...props}
    />
  )
}
export function TBody({ className, ...props }: ComponentProps<'tbody'>) {
  return <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props} />
}
export function TR({ className, ...props }: ComponentProps<'tr'>) {
  return (
    <tr
      className={cn(
        'border-b border-border/50 transition-colors even:bg-muted/50 hover:bg-primary/[0.06] data-[state=selected]:bg-primary/[0.08] dark:even:bg-muted/30 dark:hover:bg-primary/10',
        className,
      )}
      {...props}
    />
  )
}
export function TH({ className, ...props }: ComponentProps<'th'>) {
  return (
    <th
      className={cn(
        'h-11 px-4 text-left align-middle text-[11px] font-bold uppercase tracking-wider text-brand-navy dark:text-brand-sky',
        className,
      )}
      {...props}
    />
  )
}
export function TD({ className, ...props }: ComponentProps<'td'>) {
  return <td className={cn('px-4 py-3 align-middle', className)} {...props} />
}
